import { DashboardGridOptions, DashboardWidgetInstance } from '../layout/dashboard-layout';

/** How narrow the grid may get while customizing: until its narrowest widget would drop below the minimum width */
export function editingMinWidthPx(
  widgets: readonly Pick<DashboardWidgetInstance, 'w'>[],
  { columns, gapPx, editingMinWidgetWidthPx }: DashboardGridOptions,
): number {
  const columnPx = Math.max(0, ...widgets.map(({ w }) => Math.ceil((editingMinWidgetWidthPx - (w - 1) * gapPx) / w)));
  return columnPx === 0 ? 0 : columns * columnPx + (columns - 1) * gapPx;
}
